export const locale = localStorage.getItem("__extraconomy_locale");
